import { DependentMappings } from '@components/field-mapperV2/field-mapperV2'
import { DefaultMappings, FieldMappingType } from '@components/field-mapperV2/utils'
import { RequiredDateFilterDefault } from '@components/integration-filters/components'
import { DataOption } from '../integration-form-fields'
import { FilterField } from '../integration-form-fields/integration-filters/types'

export interface BaseIntegrationFieldConfig {
  placement: number
  isHidden?: boolean
}

export interface FilterFieldConfig extends BaseIntegrationFieldConfig {
  filters: FilterField[]
}

export function getFilterFieldConfig(fieldConfig: any): FilterFieldConfig | null {
  return Object.keys(fieldConfig).includes('filters') ? fieldConfig : null
}

export interface IntegrationFiltersFieldConfig extends BaseIntegrationFieldConfig {
  dataTypeFilter?: string
  requiredDateFilterDefaults?: RequiredDateFilterDefault[]
  previousYearsRestriction?: number
}

export function getIntegrationFiltersFieldConfig(
  fieldConfig: any,
): IntegrationFiltersFieldConfig | null {
  return Object.keys(fieldConfig).includes('dataTypeFilter') ? fieldConfig : null
}

export interface AccountSelectionConfig extends BaseIntegrationFieldConfig {
  resetOnAccountChange?: boolean
  mappingsToReset?: any
  disabled?: boolean
  dataType?: string
}

export function getAccountSelectionConfig(fieldConfig: any): AccountSelectionConfig | null {
  return Object.keys(fieldConfig).includes('resetOnAccountChange') ? fieldConfig : null
}

export interface SyncScheduleFieldConfig extends BaseIntegrationFieldConfig {
  disabled: boolean
}

export function getSyncScheduleFieldConfig(fieldConfig: any): SyncScheduleFieldConfig | null {
  return Object.keys(fieldConfig).includes('disabled') ? fieldConfig : null
}

export interface DataSelectionFieldConfig extends BaseIntegrationFieldConfig {
  dataOptions: DataOption[]
  metadataKey: string
  defaultValue?: string
  resetIntegrationOnChange?: boolean
  filtersToReset?: string[]
  mappingsToReset?: any
  disabled?: boolean
}

export function getDataSelectionFieldConfig(fieldConfig: any): DataSelectionFieldConfig | null {
  return Object.keys(fieldConfig).includes('dataOptions') ? fieldConfig : null
}

export interface CustomFieldConfig extends BaseIntegrationFieldConfig {
  customField: React.ReactNode
}

export function getCustomFieldConfig(fieldConfig: any): CustomFieldConfig | null {
  return Object.keys(fieldConfig).includes('customField') ? fieldConfig : null
}

export interface FieldMappingFieldConfig extends BaseIntegrationFieldConfig {
  integrationTitle: string
  mappingType: FieldMappingType
  integrationFieldsFilter?: (field: any) => boolean
  mappingsDisabled?: boolean
  defaultMappings?: DefaultMappings
  dependentMappings?: DependentMappings
  dataType?: string
  includeCreativeClassification?: boolean
}

export function getFieldMappingFieldConfig(fieldConfig: any): FieldMappingFieldConfig | null {
  return Object.keys(fieldConfig).includes('integrationTitle') ? fieldConfig : null
}

export interface DropDownFieldConfig extends BaseIntegrationFieldConfig {
  title: string
  description?: string
  selected: string | string[] | null
  options: any[]
  metadataKey: string
  label: string
  waitingOnDependancy?: boolean
  dependancyTitle?: string
  isLoading?: boolean
  isMulti?: boolean
}

export function getDropDownFieldConfig(fieldConfig: any): DropDownFieldConfig | null {
  return Object.keys(fieldConfig).includes('options') ? fieldConfig : null
}

export interface TextFieldConfig extends BaseIntegrationFieldConfig {
  title: string
  description?: string
  textValue: string | null
  label: string
  metadataKey: string
}

export function getTextFieldConfig(fieldConfig: any): TextFieldConfig | null {
  return Object.keys(fieldConfig).includes('textValue') ? fieldConfig : null
}

export interface MessageFieldConfig extends BaseIntegrationFieldConfig {
  title?: string
  message: string
  messageType: MessageFieldType
}

export function getMessageFieldConfig(fieldConfig: any): MessageFieldConfig | null {
  return Object.keys(fieldConfig).includes('messageType') ? fieldConfig : null
}

export type MessageFieldType = 'warning' | 'info' | 'error'

export interface CheckboxFieldConfig extends BaseIntegrationFieldConfig {
  label: string
  checked: boolean
  metadataKey: string
}

export function getCheckboxFieldConfig(fieldConfig: any): CheckboxFieldConfig | null {
  return Object.keys(fieldConfig).includes('checked') ? fieldConfig : null
}

export type IntegrationFieldConfigs =
  | BaseIntegrationFieldConfig
  | FilterFieldConfig
  | SyncScheduleFieldConfig
  | DataSelectionFieldConfig
  | CustomFieldConfig
  | FieldMappingFieldConfig
  | DropDownFieldConfig
  | AccountSelectionConfig
  | TextFieldConfig
  | MessageFieldConfig
  | CheckboxFieldConfig
